import { axiosInstance } from '../../utils/axios-instance'

const state = () => ({
  slide: {},
  inProgress: false
})

const mutations = {
  setSlide (state, slide) {
    state.slide = slide
  },
  setProgress (state, inProgress) {
    state.inProgress = inProgress
  }
}

const actions = {
  async buySlide ({ state, dispatch, commit }, { gtag, matomo }) {
    commit('setProgress', true)
    state.inProgress = true
    try {
      let response = await axiosInstance.get(`slides/${state.slide.id}/buy/`)
      await dispatch('spendCredits', state.slide.value, { root: true })
      commit('panel/setSlideBought', state.slide.id, { root: true })
      gtag.event(
        'purchase', {
          value: state.slide.value,
          transaction_id: response.data.id,
          items: [
            {
              item_id: state.slide.id,
              item_name: state.slide.title,
              price: state.slide.value,
              quantity: 1
            }
          ]
        }
      )
      matomo && matomo.trackEvent('slides', 'purchase', state.slide.title)
      response = await dispatch('download', { gtag, matomo, slide: state.slide })
      return response
    } finally {
      commit('setProgress', false)
    }
  },
  async download ({ commit }, { gtag, slide, matomo }) {
    commit('setProgress', true)
    const response = await axiosInstance.get(
      `/slides/${slide.id}/download/`,
      { responseType: 'arraybuffer' }
    )
    commit('setProgress', false)
    gtag.event(
      'download', {
        event_category: 'engagement',
        event_label: slide.title
      }
    )
    matomo && matomo.trackEvent('slides', 'download', slide.title)
    return response
  }
}

export default { namespaced: true, state, mutations, actions }
